import { SongCompositionDTO } from './dtos'

/**
 * An enum used to represent the current status of a mint job
 * Order of operations is static; audio must first be rendered, then uploaded.
 * Once uploaded, we mint stem/sample tokens, then mint the song token.
 */
export enum MintStatus {
  Error = 0, // Something bad happened
  Queued = 1, // Job has been queued, work has not yet begun
  MintingSong = 2, // Minting the song token
  RenderingAndUploadingAudio = 3, // Offline rendering and uploading of WAVs
  Deprecated_4 = 4, // DEPRECATED
  RegisteringStemTokens = 5, // Registering stem tokens (no minting)
  Deprecated_6 = 6, // DEPRECATED.
  RegisteringSongToArp = 7, // waiting for the song to be registered to ARP
  WaitingForSongRegistrationConfirmation = 8, // waiting for the song to be registered to ARP

  MintingAndRegisteringSoundToken = 10, // Minting sound token
  WaitingForSoundMintConfirmation = 11, // Waiting for sound token mint + registration to get confirmed

  Complete = 9 // Job is done
}

export type RenderUploadMessageDto = {
  jobId: string
  index: number
}

export type RenderInstance = {
  id?: number
  jobId: string
  index: number
  isSong: boolean
  songCompositionDto: SongCompositionDTO
  isComplete: boolean
  dataUri: string
  createdTimestamp: number
  lastModifiedTimestamp?: number
}
